import {newsSourceNamePipe, NewsSourceNamePipe} from "./news-source-name/NewsSourceNamePipe";
import {newsVendorPipe, NewsVendorPipe} from "./news-vendor-name/NewsVendorNamePipe";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.pipes`;
    return angular.module(moduleName, [])
                  .filter(NewsSourceNamePipe, newsSourceNamePipe)
                  .filter(NewsVendorPipe, newsVendorPipe)
                  .name;
}
